const m = window.require("@ember/application");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;